import { createFileRoute, redirect } from '@tanstack/react-router';

import { ReleasesPage } from '@/features/releases/ReleasesPage';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRole } from '@/utils/roles';

export const Route = createFileRoute('/_protected/t/$tenantId/platform/releases')({
  beforeLoad: ({ context }) => {
    if (!userHasRole(context.user, 'platform-admin')) {
      throw redirect({ to: '/', replace: true });
    }
  },
  component: ReleasesRoute,
});

function ReleasesRoute() {
  const { tenantId } = Route.useParams();
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <ReleasesPage tenantId={tenantId} />
    </ErrorBoundary>
  );
}
